import { render, staticRenderFns } from "./EscolaMinisterialPublico.vue?vue&type=template&id=38a97a5f&scoped=true"
import script from "./EscolaMinisterialPublico.vue?vue&type=script&lang=js"
export * from "./EscolaMinisterialPublico.vue?vue&type=script&lang=js"
import style0 from "./EscolaMinisterialPublico.vue?vue&type=style&index=0&id=38a97a5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a97a5f",
  null
  
)

export default component.exports